function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SB-gradient",
  x1: 0,
  y1: 68,
  x2: 50,
  y2: 5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--SB-secondary)",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--SB-primary)",
  offset: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 34,
  r: 32,
  fill: "none",
  stroke: "url(#SB-gradient)",
  strokeLinejoin: "round",
  strokeWidth: 4
});

var SvgSb = function SvgSb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    d: "m27.8 42.9v12.1h7.68q3.86 0 5.71-1.48 1.87-1.5 1.87-4.58 0-3.1-1.87-4.56-1.85-1.48-5.71-1.48zm0-13.6v9.95h7.09q3.51 0 5.21-1.22 1.73-1.24 1.73-3.76 0-2.5-1.73-3.74-1.71-1.24-5.21-1.24zm-4.79-3.67h12.2q5.47 0 8.44 2.12 2.96 2.12 2.96 6.04 0 3.03-1.52 4.82t-4.46 2.23q3.53 0.708 5.47 2.96 1.97 2.23 1.97 5.59 0 4.42-3.22 6.83t-9.17 2.41h-12.7z",
    fill: "var(--SB-secondary)",
    strokeWidth: 4.43,
    style: {
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.9 10.4v4.36c-1.82-0.811-3.53-1.42-5.14-1.81-1.61-0.398-3.17-0.597-4.67-0.597-2.61 0-4.62 0.472-6.04 1.42-1.41 0.944-2.11 2.29-2.11 4.02 0 1.46 0.466 2.57 1.4 3.32 0.948 0.737 3.39 1.3 5.29 1.83 0.945 0.265 1.01 0.314 2.86 0.839 1.85 0.528 5.72 2.01 7.41 3.61 1.71 1.59 2.8 3.35 2.8 6.03 0 3.2-0.81 5.43-3.12 7.08-2.29 1.65-5.66 2.48-10.1 2.48-1.67 0-3.46-0.177-5.36-0.531-1.88-0.354-3.08-0.786-5.1-1.48l6.7e-4 -4.04c0.635 0.254 3.09 1.13 4.96 1.64 1.86 0.516 3.42 0.655 5.22 0.655 2.73 0 5.12-0.383 6.61-1.39 1.49-1 2.06-1.97 1.98-3.92-0.0595-1.49-0.569-2.4-1.52-3.33-0.432-0.373-1.01-0.811-1.67-1.29-0.887-0.65-2-1.29-3.42-1.61l-2.92-0.531c-3.57-0.663-6.15-1.7-7.75-3.12s-2.39-3.38-2.39-5.9c0-2.92 1.1-5.22 3.29-6.9 2.21-1.68 5.25-2.52 9.12-2.52 1.66 0 3.35 0.14 5.07 0.42s3.48 0.7 5.29 1.26z",
    fill: "var(--SB-primary)",
    strokeWidth: 4.43,
    style: {
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SB.7277acbd.svg";
export { ForwardRef as ReactComponent };